import {
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import { ExamLocationService } from '../../services';
import { ListFilter } from '../../types';

@Component({
  selector: 'app-exam-location-page',
  templateUrl: './exam-location-page.component.html',
  styleUrls: ['./exam-location-page.component.scss'],
})
export class ExamLocationPageComponent implements OnInit {
  @HostBinding('class.table-page-component')
  hostClass = true;
  constructor(private service: ExamLocationService) {}

  ngOnInit(): void {
    this.service.loadList();
  }

  get filter(): ListFilter {
    return this.service.listState.filter;
  }

  get total(): number {
    return this.service.listState.response.total;
  }

  get loading(): boolean {
    return this.service.listState.loading;
  }

  load(): void {
    this.service.loadList();
  }
}
